<template>
  <Teleport to="body">
    <div
      class="fixed top-0 left-0 right-0 z-[55] flex flex-col items-center justify-center h-screen p-6 overflow-x-hidden overflow-y-auto bg-black/50">
      <div
        class="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-md shadow-black/5 sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <div class="sm:flex sm:items-start">
          <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
              <slot name="title"> {{ $t('common.actions.delete') }} </slot>
            </h3>
            <div class="mt-2">
              <div class="text-sm text-gray-500">
                <slot name="text"> {{ $t('messages.info.deleteRecords') }} </slot>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <button
            @click="emit('confirm')"
            type="button"
            class="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-theme-600 hover:bg-theme-500 sm:ml-3 sm:w-auto">
            <slot name="buttonText"> {{ $t('common.actions.delete') }} </slot>
          </button>
          <button
            @click="emit('cancel')"
            type="button"
            class="inline-flex justify-center w-full px-3 py-2 mt-3 text-sm font-semibold text-gray-900 bg-white rounded-md shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">
            {{ $t('common.actions.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const emit = defineEmits(['cancel', 'confirm']);
</script>
